import i18n from 'i18n/config';
import { MutableRefObject } from 'react';
import { CustomAsyncSelectOption } from '../types/CustomAsyncSelectOption';

type GetOptionsData = {
  inputValue: string;
  minimumInputLength?: number;
  defaultOptions?: { value: string; label: string; isDisabled?: boolean }[];
  addOption?: { value: string; label: string; isDisabled?: boolean };
  noDataLabel?: string;
  errorLabel?: string;
  lastCallbackTerm: MutableRefObject<string>; // eslint-disable-line
  fetchData: (
    searchTerm: string // eslint-disable-line
  ) => Promise<{ value: string; label: string; isDisabled?: boolean }[]>; // eslint-disable-line
};

export const getOptionsData = async ({
  inputValue,
  addOption,
  noDataLabel,
  errorLabel,
  lastCallbackTerm,
  fetchData,
}: GetOptionsData): Promise<CustomAsyncSelectOption[]> => {
  try {
    const options = await fetchData(inputValue);
    if (lastCallbackTerm.current !== inputValue) return [];

    if (options.length > 0) {
      return [...options, ...(addOption ? [addOption] : [])];
    }

    return [
      {
        value: 'no-results',
        label: noDataLabel || i18n.t('NoData'),
        isDisabled: true,
      },
      ...(addOption ? [addOption] : []),
    ];
  } catch {
    return [
      {
        value: 'error',
        label: errorLabel || i18n.t('ErrorLoadingData'),
        isDisabled: true,
      },
      ...(addOption ? [addOption] : []),
    ];
  }
};
